// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"077998e3","465":"b900e6d9","528":"ba7e8a2c","678":"d175a6b9","991":"17131ccf"}[chunkId] + ".chunk.css";
};